var map = {
	"./coc/en_US.md": [
		"f34e",
		"chunk-2d22c4f4"
	],
	"./coc/fr_FR.md": [
		"c7bb",
		"chunk-2d217c6a"
	],
	"./collective/en_US.md": [
		"9ea9",
		"chunk-2d0f113a"
	],
	"./collective/fr_FR.md": [
		"0043",
		"chunk-2d0a2d75"
	],
	"./faqs/en_US.md": [
		"9721",
		"chunk-2d0e5ed3"
	],
	"./faqs/ru_RU.md": [
		"a8e7",
		"chunk-2d20979f"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39e5";
module.exports = webpackAsyncContext;